import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["remove"]

  remove() {
    // event goes first as the this.element might be removed by the controller
    this.dispatch('removed')
    for (const target of this.removeTargets) {
      useViewTransition(() => target.remove())
    }
  }

  removeIfClickOutside(event) {
    for (const target of this.removeTargets) {
      if (!target.contains(event.target)) {
        useViewTransition(() => target.remove())
      }
    }
  }
}
